import { useEffect, useState } from "react";
import { http, asArray } from "@/lib/api";

const SITE = "https://www.pricehub.info";
const setMeta = (sel, attr, value) => {
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement(sel.startsWith("link") ? "link" : "meta");
    const [, k, v] = sel.match(/\[(\w+)="([^"]+)"\]/);
    el.setAttribute(k, v);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

/** Per-page title, description and canonical URL (crawlers that run JS and the prerenderer read these). */
export function usePageTitle(title, description) {
  useEffect(() => {
    const full = title ? `${title} | PRICEHUB` : "PRICEHUB — Every Brand. Every Price List.";
    document.title = full;
    const url = `${SITE}${window.location.pathname === "/" ? "/" : window.location.pathname.replace(/\/$/, "")}`;
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:title"]', "content", full);
    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
    }
  }, [title, description]);
}

export function useFetch(path, fallback) {
  const [state, setState] = useState({ data: fallback, loading: true, error: null });
  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    http.get(path)
      .then(({ data }) => { if (alive) setState({ data: data ?? fallback, loading: false, error: null }); })
      .catch((error) => { if (alive) setState({ data: fallback, loading: false, error }); });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);
  return state;
}

export function useBrands() {
  const { data, loading, error } = useFetch("/brands?limit=500", []);
  return { brands: asArray(data), loading, error };
}

const HISTORY_KEY = "ph_search_history";
export const readHistory = () => {
  try { return asArray(JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]")); } catch { return []; }
};
export const pushHistory = (term) => {
  const next = [term, ...readHistory().filter((t) => t.toLowerCase() !== term.toLowerCase())].slice(0, 6);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(next));
  return next;
};
export const clearHistory = () => { localStorage.removeItem(HISTORY_KEY); return []; };
